var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-loader-controller',{attrs:{"resource":_vm.resource},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var receive = ref.receive;
var loading = ref.loading;
var result = ref.result;
return [_c('delayed-executor-controller',{attrs:{"delay":300,"receiver":receive},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var delayedReceive = ref.receive;
return [_c('view-component',_vm._b({ref:"view",attrs:{"value":_vm.value,"filter":_vm.filter,"result":result,"loading":loading,"receive":delayedReceive,"rules":_vm.rules,"disabled":_vm.disabled,"params":_vm.params,"max-height":_vm.maxHeight},on:{"input":_vm.submit,"select":_vm.select}},'view-component',_vm.$attrs,false))]}}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }